import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { ContactsDialog } from "../../page/PersonRepositoryPage/ContactsDialog";

export function ContactPreviewButton({ personId, rowData, color = "primary" }) {
    const { openDialog: openContactsDialog } = useDialogBetter();

    return (
        <IconButton
            color={color}
            onClick={() => {
                openContactsDialog({
                    Component: ContactsDialog,
                    componentProps: {
                        personId: personId,
                        isPreview: true,
                        rowData: rowData,
                    },
                });
            }}
        >
            <VisibilityIcon />
        </IconButton>
    );
}
